<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <h3 class="mb-3">Search</h3>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-3">
                                <label for="name">Name</label>
                                <input type="text" v-validate="'alpha_spaces'" v-model="form.name" id="name" name="name"
                                    class="form-control form-control-sm" placeholder="Search by name" />
                            </div>

                            <div class="col-md-3">
                                <label for="name">Email</label>
                                <input type="email" v-validate="'email'" v-model="form.email" id="name" name="name"
                                    class="form-control form-control-sm" placeholder="Search by email" />
                            </div>

                            <div class="col-md-3">
                                <label for="name">From</label>
                                <input type="date" v-model="form.from_date" id="name" name="name"
                                    class="form-control form-control-sm" placeholder="Search by date" />
                            </div>

                            <div class="col-md-3">
                                <label for="name">To</label>
                                <input type="date" v-model="form.to_date" id="name" name="name"
                                    class="form-control form-control-sm" placeholder="Search by date" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-6 custom-search">
                                <button class="btn btn-success btn-sm custom-search-button"
                                    @click.prevent="search()">Search</button>
                            </div>
                        </div>
                    </form>
                </b-card>
            </div>
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px" />
                    <div v-if="loginLogs.length > 0" class="row mb-2">
                        <div class="col-sm-4">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ loginLogs.length }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Browser</th>
                                    <th>IP</th>
                                    <th>Logged-in At</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in loginLogs" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.user.name }}</td>
                                    <td>{{ item.user.email }}</td>
                                    <td>{{ item.browser }}</td>
                                    <td>{{ item.ip }}</td>
                                    <td>{{ new Date(item.created_at).toLocaleDateString('en-IN') }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h5 v-if="loginLogs.length === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
        <user-logged :user_logged="user_logged" @userLogged="userLogged"></user-logged>
    </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

import moment from "moment";
import UserLogged from "../../modals/UserLogged";

export default {
    page: {
        title: "Login record",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, UserLogged },
    data() {
        return {
            title: "Login Record History",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "User List",
                    active: true
                }
            ],
            loginLogs: [],
            btn_edit: false,
            user_logged: '',
            form: {
                name: '',
                email: '',
                from_date: '',
                to_date: ''
            },
        };
    },

    mounted() {
        this.getloginLogs();
    },
    methods: {
        getloginLogs() {
            http.get("api/users/logged/list").then(response => {
                if (!response.error) {
                    this.loginLogs = response.data;
                }
            });
        },
        userLogged(user_logged, action) {
            this.user_logged = user_logged.filter(p => p.action === action);
        },
        customCreatedDate(date) {
            return moment(date).format("YYYY-MM-DD, h:mm:ss a");
        },
        search() {
            this.$validator.validate().then(valid => {
                http.post("api/users/logged/list", this.form).then(response => {
                    this.loginLogs = response.data;
                });
            })
        }
    },
};
</script>
